// These are the AzureAD roles that are allowed to get into our app.
// This is just the very first level of security
// above and beyond this we have set of specific permissions
export const UserRoles = [
  'All ACHC Users'
]
